import { StringOptions } from "../../../../../components/Select";
import { SortDir, SortKey, SortState } from "./types";

// Card list (mobile) sort is a single select, so each sortable dimension is
// flattened into an explicit direction. Mirrors the desktop table sort keys.
export const SORT_OPTIONS: StringOptions[] = [
  { label: "↓ Since", value: "since:desc" },
  { label: "↑ Since", value: "since:asc" },
  { label: "↓ Balance", value: "balance:desc" },
  { label: "↑ Balance", value: "balance:asc" },
  { label: "↓ Deposited", value: "deposited:desc" },
  { label: "↑ Deposited", value: "deposited:asc" },
  { label: "↓ Withdrawn", value: "withdrawn:desc" },
  { label: "↑ Withdrawn", value: "withdrawn:asc" },
  { label: "↓ Earned", value: "earned:desc" },
  { label: "↑ Earned", value: "earned:asc" },
];

export const sortStateToValue = ({ key, dir }: SortState): string =>
  `${key}:${dir}`;

export const valueToSortState = (value: string): SortState => {
  const [key, dir] = value.split(":");
  return { key: key as SortKey, dir: dir as SortDir };
};
